import { MappedProduct } from '@/fo/util/map-product-data';

interface EventSelectVariantProduct {
  product: MappedProduct;
}

export const EVENT_SELECT_VARIANT_PRODUCT = 'select-variant-product';
export const EVENT_OPEN_CONFIG_MODAL = 'open-config-modal';
export const EVENT_CLOSE_CONFIG_MODAL = 'close-config-modal';

export const utilEventConfigurableProduct = {
  open: (product: EventSelectVariantProduct['product']) => {
    window.dispatchEvent(
      new CustomEvent<EventSelectVariantProduct>(EVENT_OPEN_CONFIG_MODAL, {
        detail: { product: product }
      })
    );
  },

  close: () => {
    window.dispatchEvent(new CustomEvent(EVENT_CLOSE_CONFIG_MODAL));
  },

  onOpen: (
    callback: (product: EventSelectVariantProduct['product']) => void
  ) => {
    const handler = (e: CustomEvent<EventSelectVariantProduct>) => {
      callback(e.detail.product);
    };

    window.addEventListener(EVENT_OPEN_CONFIG_MODAL, handler as EventListener);

    return () => {
      window.removeEventListener(
        EVENT_OPEN_CONFIG_MODAL,
        handler as EventListener
      );
    };
  },

  onClose: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_CLOSE_CONFIG_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_CLOSE_CONFIG_MODAL, handler);
    };
  },

  selectProduct: (product: EventSelectVariantProduct['product']) => {
    window.dispatchEvent(
      new CustomEvent<EventSelectVariantProduct>(EVENT_SELECT_VARIANT_PRODUCT, {
        detail: { product: product }
      })
    );
  },

  onProductSelect: (
    callback: (product: EventSelectVariantProduct['product']) => void
  ) => {
    const handler = (e: CustomEvent<EventSelectVariantProduct>) => {
      callback(e.detail.product);
    };

    window.addEventListener(
      EVENT_SELECT_VARIANT_PRODUCT,
      handler as EventListener
    );
    return () => {
      window.removeEventListener(
        EVENT_SELECT_VARIANT_PRODUCT,
        handler as EventListener
      );
    };
  }
};
